import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Main.css';
import Header from  './Header';
import TopTeaser from  './elements/TopTeaser';
import FilterBar from  './FilterBar';
import RestaurantsItems from  './elements/RestaurantsItems';
import Footer from  './Footer';

import {loadApi} from './../actions'

class Main extends Component {
	


	componentDidMount() {
		// Get ID from URL
		//const URLsegments = this.props.location.pathname.slice(1).split('/');
		this.props.dispatch(loadApi())
	}

	render() {

		return (

			<div className='mainContainer'>
				
				<Header />				
				<TopTeaser />
				<FilterBar />
				<RestaurantsItems  />
				<Footer />
			</div>
		);
	}
}

// restaurantsSelected
const mainProps = state => {
	//console.log(state.main.restaurantsSelected);
	return {
		restaurantsSelected: state.main.restaurantsSelected,
	}
}

export default connect(mainProps)(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js